import { ModuloCard } from "@/components/dashboard/ModuloCard";
import { Skeleton } from "@/components/ui/skeleton";
import { useModuli } from "@/hooks/useModuli";

/**
 * Griglia di `ModuloCard` in variante compatta per la vista d'insieme
 * (direzione / staff): un colpo d'occhio su moduli accessibili e relativi agenti.
 * Limitata ai moduli funzionali M1–M5.
 */
export function WidgetTeamModuli() {
  const { data: moduli, isLoading } = useModuli();

  if (isLoading) {
    return (
      <div className="grid gap-2 sm:grid-cols-2">
        <Skeleton className="h-16 w-full" />
        <Skeleton className="h-16 w-full" />
      </div>
    );
  }

  const funzionali = (moduli ?? []).filter((m) => /^M[1-5]$/.test(m.codice));
  if (funzionali.length === 0) {
    return (
      <p className="text-xs text-muted-foreground">Nessun modulo accessibile.</p>
    );
  }

  return (
    <div className="grid gap-2 sm:grid-cols-2">
      {funzionali.map((m) => (
        <ModuloCard
          key={m.codice}
          titolo={m.nome}
          config={{ modulo_codice: m.codice, variante: "compact" }}
        />
      ))}
    </div>
  );
}
